import { 
    TrackingService
} from 'sharebase/services';
import { CommonUtilsService} from 'util/services';
import {
    ContextMenuItem,
    MenuItemContext
} from 'sharebase/domain';

export class AnalyticsMenuItem extends ContextMenuItem {
    constructor(
        utils:CommonUtilsService,
        $q:ng.IQService,
        protected sbTrackingService:TrackingService,
        public action:string, 
        public label:string, 
        public icon:string
    ){
        super(utils, $q, action, label, icon);
    }

    public clone() {
        let clone = new AnalyticsMenuItem(
            this.utils,
            this.$q,
            this.sbTrackingService,
            this.action,
            this.label,
            this.icon
        );
        
        return this.copyInstanceData(clone);
    }

    public trigger(target, event){
        let clickContext:string = '';

        if(!target){
            clickContext = 'Root';
        }
        else if(target.FolderId || Array.isArray(target)){
            clickContext = 'Folder';
        }
        else if(target.DocumentId){
            clickContext = 'Document';
        }

        switch(this.context){
            case MenuItemContext.ContextMenu:
                clickContext += ' context menu';
                break;
            case MenuItemContext.SelectionBar:
                clickContext += ' selection bar';
                break;
            case MenuItemContext.Toolbar:
                clickContext += ' toolbar';
                break;
        }

        this.sbTrackingService.trackClick(this.action, clickContext.trim());
        return super.trigger(target, event);
    }
}

export class AnalyticsMenuItemFactory {
	static readonly $inject = [
		'utils',
        '$q',
        'sbTrackingService'
	];

	constructor(
		private utils:CommonUtilsService, 
        private $q:ng.IQService,
        private sbTrackingService:TrackingService
	) {}

	public create(action:string, label:string, icon:string) {
		return new AnalyticsMenuItem(this.utils, this.$q, this.sbTrackingService, action, label, icon);
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/domain/analyticsMenuItem.ts